import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'pakistan_provide_required_time_off_iddat'

export const dataPointDefinition = {
  retracedId: 'pakistan_provide_required_time_off_iddat',
  name: 'Pakistan: Provide required time off for Iddat',
  description:
    'This question is specific to Pakistan only. Please consult the Law Overlay for more information on applicable legal requirements and how to answer this question if the facility provides Iddat leave only to women and not to men.',
  meta: {
    slcpMeta: {
      key: 'wh-wor-29x',
      number: 'WH-WOR-25-10',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wh-wor-29x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 36580,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
